<script>
import Pagination from "../Pagination.vue";
import {mapActions, mapState} from "pinia";
import {bookingFlowStore} from "../../stores/BookingFlowStore";

export default {
  name: "BookingFlow",
  components: {
    Pagination
  },
  computed: {
    ...mapState(bookingFlowStore, ['formData', 'errors', 'currentQuestion', 'lastStep', 'step', "submittingBooking", "error"]),
  },
  methods: {
    ...mapActions(bookingFlowStore, ["continueFlow", "back", "submitBooking"]),
  },
}
</script>

<template>
  <div class="booking-container-inner">
    <h1>Book your physiotherapy</h1>
    <Pagination :step="step" :total="lastStep"/>
    <div class="booking-form">
      <div class="error-message" v-if="error">
        <h4 class="text-danger">There has been an unexpected error, please refresh the page or <a
            href="/contact-us">contact us</a></h4>
      </div>
      <div id="submittingBooking p-5" v-if="submittingBooking && !error">
        <h4 class="ircc-blue">Submitting your booking, please do not refresh the page...</h4>
      </div>
      <div id="form" v-if="!submittingBooking && !error">
        <component
            v-if="!submittingBooking"
            :is="currentQuestion.component"
        />
        <ul class="form-errors" v-if="errors">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
        <hr>
        <div class="progress-btn-container mt-3">
          <div v-if="step > 1" class="progress-btn back" @click="back"><i class="fas fa-chevron-left"></i> Go Back</div>
          <div class="progress-btn" v-if="step < lastStep" @click="continueFlow">Next <i class="fas fa-chevron-right"></i>
          </div>
          <div class="progress-btn" v-if="step === lastStep" @click="submitBooking">Book now <i
              class="fas fa-chevron-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>